<template>
  <PaOverlayModal
  :appendClass="['pa-overlay-modal-default-transition-fix-for-tutorial', 'pa-tutorial-final-modal']"
  :additionalZIndex="2"
  :isOpen="isOpen"
  :position="{top: .15}"
  :isFreez="isFreezModal"
  :couldOverlaySwipeClose="false"
  contentTransitionName="trans-content"

  @closeOverlayModal="handleCloseOverlay"
  @afterEnterContent="handleEnterContent"
  @afteredAfterEnterContent="handleAfterEnterContent"
  @afterLeaveContent="handleAfterLeaveContent"
  >
    <div class="pa-tutorial-final">
      <p class="sentence-1">多々なる異世界を股にかけた</p>
      <p class="sentence-2">魅惑の異界舞踏会</p>
      <p class="sentence-3">開演で御座います。</p>
      <div class="button-field">
        <button
         class="button pa-button"
         @click.prevent="handleClickSubmit"
        >異界舞踏会へ入場する</button>
      </div>
    </div>
  </PaOverlayModal>
</template>

<script>
import PaOverlayModal from '@/components/Parts/PAOverlayModal/PAOverlayModal.vue'

export default {
  props : {
    isOpen: {
      default: false
    }
  },

  components : {
    PaOverlayModal
  },

  data(){
    return {
      isFreezModal      : false,
      isLoadedModal     : false,
    };
  },

  watch : {
    isLoadedModal(value){
      if(value === true){
        this.$emit('loadedModal');
      }
    }
  },

  methods : {
    handleCloseOverlay(){
      this.$emit('closeOverlay');
    },

    handleEnterContent(){
      this.isFreezModal = true;
    },

    handleAfterEnterContent(){
      this.$nextTick(() => {
        this.isLoadedModal = true;
      });
    },

    handleAfterLeaveContent(){
      this.isFreezModal = false;
    },

    handleClickSubmit(){
      this.$emit('onSubmit');
    }
  }
}
</script>

<style lang="scss">
.pa-tutorial-final-modal{
  .pa-tutorial-final{
    p{
      color:#ffffff;
      text-align: center;
      font-size:1rem;

      &.sentence-1{
        font-size:1.1rem;
        margin-bottom:.5rem;
      }

      &.sentence-2{
        font-size:1.4rem;
        margin:.7rem 0 .4rem;
      }

      &.sentence-3{
        font-size:1.1rem;
      }
    }

    .button-field{
      margin:1rem 0;

      button.pa-button{
        display: block;
        width:70%;
        margin:0 auto;
        border:2px solid #A4734B;
        background-color:#C49065;
        border-radius: 20px;
        color:#5E3717;
        letter-spacing: 4px;

        &.is-loading::after{
          border: 1.3px solid #5E3717;
          border-right-color: transparent;
          border-top-color: transparent;
        }
      }
    }
  }
}
</style>